// External modules
import React from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import Select from 'react-select';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';

import ACButton from '../../atoms/ACButton';
import ACStatus from '../../atoms/ACStatus';
import ACUIElement from '../../atoms/ACUIElement';
import { getDefaultItem, getDefaultSuitable } from '../../common/items';
import { getUIElement, getUIElementType, getMediaForUIName } from '../../common/global';

import styles from './SetItem.module.scss';

export default class SetItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: getDefaultItem(),
      selectedSubItem: {},
    };

    this.onChangeItemText = this.onChangeItemText.bind(this);
    this.onChangeDietaries = this.onChangeDietaries.bind(this);
    this.onChangeSuitables = this.onChangeSuitables.bind(this);
    this.onAddSuitables = this.onAddSuitables.bind(this);
    this.onSaveItem = this.onSaveItem.bind(this);

    this.onChangeItemType = this.onChangeItemType.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item && this.props.item !== nextProps.item) {
      this.setState({
        item: nextProps.item,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;
    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    console.log('media', media);
    const { item = {} } = cloneDeep(this.state);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'callOut':
        uiElement = getUIElement(item.uiElements, getUIElementType().callOut);
        break;
      case 'introduction':
        uiElement = getUIElement(item.uiElements, getUIElementType().introduction);
        break;
      default:
        break;
    }
    if (isEmpty(uiElement)) return;

    uiEleMedia = uiElement.media || {};
    uiEleMedia.url = url;
    uiElement.media = uiEleMedia;
    this.updateItemUIElementData(cloneDeep(uiElement));
  }

  onChangeItemText = (key, event) => {
    let item = cloneDeep(this.state.item);
    const value = event.target.value;

    item[key] = value;

    this.setState({
      item,
    });
  };

  onChangeTax = (event) => {
    let { item } = this.state;
    let { tax = {} } = item;

    const { value } = event.target;

    tax.amount = Number(value);
    item.tax = tax;
    this.setState({
      item,
    });
  };

  onChangeDietaries(key) {
    let item = cloneDeep(this.state.item);
    item.dietaries[key] = !item.dietaries[key];

    this.setState({
      item,
    });
  }

  /**
   * Whether a ticket has to be bought and attached for this item, per booking.
   *
   * The requirement lives on the item so one flag covers both a stop on a normal route and the
   * automatic one-stop route a component gets when it is delivered by this item. It replaced
   * the component-level ticket content slot, whose provider was free text.
   *
   * The booking URL and instructions are cleared with the flag, so a switched-off item cannot
   * keep a stale link that reads as current.
   */
  onChangeTicketRequired = () => {
    let item = cloneDeep(this.state.item);
    item.ticketRequired = !item.ticketRequired;
    if (!item.ticketRequired) {
      item.ticketBookingUrl = null;
      item.ticketInstructions = null;
    }

    this.setState({ item });
  };

  onChangeTicketField = (key) => (event) => {
    let item = cloneDeep(this.state.item);
    item[key] = event.target.value;

    this.setState({ item });
  };

  onChangeSuitables(index, key, event) {
    const value = event.target.value;

    let item = this.state.item;
    item.suitables[index][key] = parseInt(value);

    this.setState({
      item,
    });
  }

  onAddSuitables() {
    let item = this.state.item;
    item.suitables.push(getDefaultSuitable());

    this.setState({
      item,
    });
  }

  onChangeItemType = (itemType) => {
    let { item } = cloneDeep(this.state);
    const value = itemType.value;

    item['type'] = value;

    this.setState({
      item,
    });
  };

  onChangeSubItem = (subItem) => {
    this.setState({
      selectedSubItem: subItem,
    });
  };

  onAddSelectedSubItem = (subItem) => {
    const { item } = cloneDeep(this.state);
    const { object = {} } = cloneDeep(subItem);
    let { subItems = [] } = cloneDeep(item);

    if (isEmpty(subItem)) return null;
    const index = subItems.findIndex((sItem) => sItem.id === object.id);
    if (index >= 0) return null;

    subItems.push(object);

    item.subItems = subItems;
    this.setState({ item, selectedSubItem: {} });
  };

  onDeleteSubItem = (subItem) => {
    const { item } = cloneDeep(this.state);

    let { subItems = [] } = cloneDeep(item);

    const index = subItems.findIndex((sItem) => {
      return sItem.id === subItem.id;
    });

    if (index < 0) return null;
    subItems.splice(index, 1);

    item.subItems = subItems;
    this.setState({ item });
  };

  onSaveItem() {
    let item = this.state.item;

    // Convert price
    item.price = parseFloat(item.price);
    this.props.onSaveItemFunc(item);
    this.props.onCloseFunc();
  }

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().item, name: name, s3FolderName: s3FolderName };
    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  };

  updateItemUIElementData(uiElement) {
    const { item = {} } = cloneDeep(this.state);
    let { uiElements = [] } = item;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);

    item.uiElements = uiElements;
    this.setState({
      item,
    });
  }

  onChangeACUIElement = (uiElement) => {
    this.updateItemUIElementData(uiElement);
  };

  renderItemTypes() {
    const { type = '' } = this.state.item;
    const { itemTypes = [] } = cloneDeep(this.props);

    if (isEmpty(itemTypes)) return <div />;

    let mItemTypes = [];
    let mSelectedItemType = {
      label: '',
      value: '',
    };
    if (!isEmpty(type)) {
      const findItemType = itemTypes.filter((i) => {
        return i.value === type;
      });

      if (!isEmpty(findItemType))
        mSelectedItemType = {
          label: findItemType[0].name,
          value: findItemType[0].value,
        };
    }
    itemTypes.forEach((it) => {
      mItemTypes.push({
        label: it.name,
        value: it.value,
      });
    });

    return (
      <div className={styles.itemTypesContainer}>
        <span
          style={{
            fontSize: '12px',
            width: '100px',
          }}
        >
          Item Type
        </span>
        <Select
          className={styles.itemTypeSelect}
          inputId="react-select-single"
          TextFieldProps={{
            label: 'ItemType',
            InputLabelProps: {
              htmlFor: 'react-select-single',
              shrink: true,
            },
            placeholder: 'Select an Item Type',
          }}
          options={mItemTypes}
          value={mSelectedItemType}
          onChange={this.onChangeItemType}
        />
      </div>
    );
  }

  renderSuitable(index, suitable) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Adult
              </InputAdornment>
            ),
          }}
          value={suitable.adults}
          className={styles.suitableTextField}
          onChange={(e) => this.onChangeSuitables(index, 'adults', e)}
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Children
              </InputAdornment>
            ),
          }}
          value={suitable.children}
          className={styles.suitableTextField}
          onChange={(e) => this.onChangeSuitables(index, 'children', e)}
        />
      </div>
    );
  }

  renderSuitables(suitables) {
    let suitablesComponents = [];
    if (suitables) {
      for (let i = 0; i < suitables.length; i++) {
        suitablesComponents.push(this.renderSuitable(i, suitables[i]));
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {suitablesComponents}
      </div>
    );
  }

  renderSubItemsDropDown(subItems, selectedSubItem) {
    let mSubItems = [];
    if (isEmpty(subItems)) return <div />;
    subItems.forEach((sItem) => {
      mSubItems.push({
        label: sItem.name,
        value: sItem.id,
        object: sItem,
      });
    });
    return (
      <div className={styles.subItemsContainer}>
        <span
          style={{
            fontSize: '12px',
            width: '100px',
          }}
        >
          Sub item
        </span>
        <div style={{ width: '100%', display: 'flex' }}>
          <Select
            className={styles.subItemSelect}
            inputId="react-select-single"
            TextFieldProps={{
              label: 'Select a SubItem',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select a SubItem',
            }}
            options={mSubItems}
            value={selectedSubItem}
            onChange={this.onChangeSubItem}
          />
          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon key="iconAddSubItem" />}
            key="btnAddSubItem"
            onClickFunc={() => this.onAddSelectedSubItem(selectedSubItem)}
          />
        </div>
      </div>
    );
  }

  renderSelectedSubItem(subItem) {
    return (
      <div className={styles.selectedSubItem} key={subItem.id}>
        <div>{subItem.name}</div>
        <div
          style={{ marginLeft: 'auto', marginRight: '0px' }}
          onClick={() => this.onDeleteSubItem(subItem)}
        >
          <DeleteIcon
            style={{
              color: '#FF765F',
              cursor: 'pointer',
            }}
          />
        </div>
      </div>
    );
  }

  renderSelectedSubItems(selectedSubItems) {
    if (isEmpty(selectedSubItems)) return <div />;

    return (
      <div className={styles.selectedSubItems}>
        {selectedSubItems.map((sItem) => {
          return this.renderSelectedSubItem(sItem);
        })}
      </div>
    );
  }

  renderCallOut() {
    const mediaFor = 'generic';
    const { item = {} } = cloneDeep(this.state);
    const { uiElements } = item;
    const callOut = getUIElement(uiElements, getUIElementType().callOut);
    const { media = {} } = callOut;
    if (isEmpty(media.type)) media.type = 'image';
    callOut.media = media;
    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Call Out</div>
        <ACUIElement
          name="callOut"
          mediaName="itemCallOut"
          mediaFor={mediaFor}
          uiElement={callOut}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          isMediaTypeDisabled={true}
        />
      </div>
    );
  }

  renderIntroduction() {
    const mediaFor = 'generic';
    const { item = {} } = cloneDeep(this.state);
    const { uiElements } = item;
    const introduction = getUIElement(uiElements, getUIElementType().introduction);
    const { media = {} } = introduction;
    if (isEmpty(media.type)) media.type = 'image';
    introduction.media = media;
    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Introduction</div>
        <ACUIElement
          name="introduction"
          mediaFor={mediaFor}
          uiElement={introduction}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          isMediaTypeDisabled={true}
        />
      </div>
    );
  }

  render() {
    const { item, selectedSubItem } = cloneDeep(this.state);
    const { suitables = [], dietaries = {}, tax = {} } = item;

    const selectedSubItems = item.subItems || []; // This is list of the sub items selected under the parent item.
    const { subItems = [] } = cloneDeep(this.props);
    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Set Items</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                </div>
              </div>
              <div className={styles.middle}>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span className={styles.title}>Details</span>
                    <ACStatus
                      type="provider"
                      status={item.status}
                      isEditable={true}
                      onChangeFunc={(e) => this.onChangeItemText('status', e)}
                    />
                  </div>
                  <div>
                    {this.renderItemTypes()}
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Item Name
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={item.name}
                      onChange={(e) => this.onChangeItemText('name', e)}
                      placeholder="What items are we purchasing here?"
                    />
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Item Price
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={item.price}
                      type="number"
                      onChange={(e) => this.onChangeItemText('price', e)}
                    />
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Tax (amount)
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      //value={tax.amount || ''}
                      value={tax.amount}
                      type="number"
                      onChange={this.onChangeTax}
                    />
                    {this.renderSubItemsDropDown(subItems, selectedSubItem)}
                    {this.renderSelectedSubItems(selectedSubItems)}
                  </div>
                </div>
                <div>
                  <span className={styles.title}>Ticket</span>
                  <div style={{ marginTop: '20px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={!!item.ticketRequired}
                          onChange={this.onChangeTicketRequired}
                        />
                      }
                      label="A ticket must be bought and attached for this item"
                    />
                    <div style={{ fontSize: '12px', color: '#777', marginBottom: '10px' }}>
                      Covers both a stop on a normal route and the automatic stop a component
                      gets when it is delivered by this item. Saving any item change raises a
                      "Route Changed!" alert on every live booking of every route using it.
                    </div>
                    {item.ticketRequired && (
                      <div>
                        <TextField
                          className={styles.textField}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" className={styles.adornment}>
                                Booking URL
                              </InputAdornment>
                            ),
                          }}
                          value={item.ticketBookingUrl || ''}
                          onChange={this.onChangeTicketField('ticketBookingUrl')}
                        />
                        <TextField
                          className={styles.textField}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" className={styles.adornment}>
                                Instructions
                              </InputAdornment>
                            ),
                          }}
                          value={item.ticketInstructions || ''}
                          onChange={this.onChangeTicketField('ticketInstructions')}
                          multiline
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <span className={styles.title}>Suitable For</span>
                  <div
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    <FormGroup
                      row
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            onChange={() => this.onChangeDietaries('vegetarian')}
                            checked={dietaries.vegetarian}
                          />
                        }
                        label="Vegetarian"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            onChange={() => this.onChangeDietaries('vegan')}
                            checked={dietaries.vegan}
                          />
                        }
                        label="Vegan"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={dietaries.glutenFree}
                            onChange={() => this.onChangeDietaries('glutenFree')}
                          />
                        }
                        label="Gluten Free"
                      />
                    </FormGroup>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {this.renderSuitables(suitables)}
                    <ACButton
                      text={'Add'}
                      icon={<AddIcon />}
                      iconLast={true}
                      onClickFunc={this.onAddSuitables}
                    />
                  </div>
                </div>
                {this.renderIntroduction()}
                {this.renderCallOut()}
              </div>
              <div className={styles.bottom}>
                <ACButton
                  text={'Save'}
                  icon={<SaveIcon />}
                  iconLast={true}
                  onClickFunc={this.onSaveItem}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
